<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-user-facilities-detail" style="background: #fff">

        <page-title :title="title ? title : 'Firma'" :back="true"></page-title>

        <form class="form form-user-facility-single-edit mt-20" @submit.prevent="postFacilityEdit">
            <slide-x-left-transition :duration="400" :delay="200">
                <div class="form-group" v-show="show">
                    <label>Nazwa firmy</label>
                    <div class="input-wrapper">
                        <input v-model="form.name"
                               type="text"
                               :class="{'input-error' : errors.name }"
                               placeholder="Podaj nazwę firmy"
                               required/>
                    </div>
                    <p class="error" v-if="errors.name">{{ errors.name[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="500" :delay="300">
                <div class="form-group" v-show="show">
                    <label>Ulica</label>
                    <div class="input-wrapper">
                        <input v-model="form.street"
                               type="text"
                               :class="{'input-error' : errors.street }"
                               placeholder="Podaj ulicę"
                               required/>
                    </div>
                    <p class="error" v-if="errors.street">{{ errors.street[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="600" :delay="400">
                <div class="form-group" v-show="show">
                    <label>Kod pocztowy</label>
                    <div class="input-wrapper">
                        <input v-model="form.zip_code"
                               v-mask="'##-###'"
                               type="text"
                               :class="{'input-error' : errors.zip_code }"
                               placeholder="Podaj województwo"
                               required/>
                    </div>
                    <p class="error" v-if="errors.zip_code">{{ errors.zip_code[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="700" :delay="500">
                <div class="form-group" v-show="show">
                    <label>Miasto</label>
                    <div class="input-wrapper">
                        <input v-model="form.city_name"
                               type="text"
                               :class="{'input-error' : errors.city_name }"
                               placeholder="Podaj miasto"
                               required/>
                    </div>
                    <p class="error" v-if="errors.city_name">{{ errors.city_name[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="800" :delay="600">
                <div class="form-group" v-show="show">
                    <label>Województwo</label>
                    <div class="select-wrapper">
                        <span v-if="form.province_slug === null" class="select-placeholder">Wybierz województwo</span>
                        <select v-model="form.province_slug" required>
                            <option v-for="item in provinces">{{ item.name }}</option>
                        </select>
                    </div>
                    <p class="error" v-if="errors.province_slug">{{ errors.province_slug[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-x-left-transition :duration="900" :delay="700">
                <div class="form-group" v-show="show">
                    <label>NIP</label>
                    <div class="input-wrapper">
                        <input v-model="form.tax_id"
                               type="text"
                               :class="{'input-error' : errors.tax_id }"
                               placeholder="Podaj NIP"
                               required/>
                    </div>
                    <p class="error" v-if="errors.tax_id">{{ errors.tax_id[0] }}</p>
                </div>
            </slide-x-left-transition>
            <slide-y-up-transition :duration="500" :delay="300">
                <ion-button v-if="show" mode="ios" expand="block" type="submit" :disabled="loading">
                    <span v-if="loading"><span class="loader"></span></span>
                    <span v-else>Zapisz</span>
                </ion-button>
            </slide-y-up-transition>
        </form>

    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import api from '@/services/Api';
    import goTo from '@/mixins/goto';
    import PageTitle from '@/components/PageTitle.vue';

    function getDefaultFormData() {
        return {
            name: '',
            province_slug: '',
            city_name: '',
            street: '',
            zip_code: '',
            tax_id: ''
        }
    }

    export default{
        name: 'UserFacilitiesDetail',
        components: { PageTitle },
        mixins: [goTo],
        props: ['title'],
        data(){
            return {
                show: false,
                form: getDefaultFormData()
            }
        },
        computed: {
            ...mapState({
                errors: state => state.facilities.errors,
                loading: state => state.facilities.loading,
                facilities: state => state.facilities.data,
                provinces: state => state.global.provinces
            })
        },
        mounted(){
            this.show = true;
            if(this.facilities.length === 0){
                this.$store.dispatch('facilities/USER_FACILITIES_REQUEST').then(resp => {
                    this.findFacilitySingle();
                });
            }else{
                this.findFacilitySingle();
            }
        },
        methods: {
            findFacilitySingle(){
                let obj = this.facilities.filter((item) => {
                    return item.slug === this.$route.params.slug;
                });
                if(obj.length > 0){
                    this.form = obj[0]
                }
            },
            postFacilityEdit() {
                let payload = {'facility_slug': this.$route.params.slug, 'data': this.form};
                this.$store.dispatch('facilities/USER_FACILITIES_UPDATE_REQUEST', payload).then(resp => {
                    this.$store.dispatch('GLOBAL_TOAST',resp.data.message);
                    this.goBack();
                });
            }
        }
    }
</script>